import { headerBannerState, headerBannerType } from "../../../constants/enums";

export const bannerAdminColumns = [
  {
    field: "module",
    header: "Módulo",
    columnType: "custom",
    render: (rowData) => {
      let moduleName = "Módulo desconocido";

      switch (rowData.id) {
        case headerBannerType.dofa:
          moduleName = "DOFA";
          break;
        case headerBannerType.riskAndOportunity:
          moduleName = "Riesgos y Oportunidades";
          break;
        case headerBannerType.accompaniment:
          moduleName = "Acompañamiento";
          break;
        case headerBannerType.createEngineeringReport:
          moduleName = "Reporte de Ingeniería";
          break;
        case headerBannerType.resume:
          moduleName = "Hoja de vida";
          break;
        case headerBannerType.inspectionReport:
          moduleName = "Acta de inspección";
          break;
        case headerBannerType.processMap:
          moduleName = "Mapa de procesos — Gestión de la Dirección";
          break;
      }

      return <p className="table-default-column">{moduleName}</p>;
    }
  },
  {
    field: "state",
    header: "Estatus",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">
        {rowData.state === headerBannerState.completed
          ? "Completada"
          : "Pendiente"}
      </p>
    )
  },
  { field: "actionButtons", header: "", columnType: "actionButtons" }
];
